let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ihToX")).then(() => parcelRequire('2jjiZ'));